import { useState, useEffect } from "react";
import { emptyCompany, ICompany } from "../../../../types/company.type";
import { Modal } from "flowbite-react";
import { createCompany, updateCompany } from "../../../../common/services/company.api";
import { useToastContext } from "../../../../common/components/ui/toast/toast.context";
import FormEditCompany from "../forms/FormEditCompany";
import Loading from "../../../../common/components/ui/loading/Loading";

type Props = {
  data: ICompany;
  companyId: string | null;
  onClose: () => void;
  onSave: (company: ICompany) => void;
};


export default function ModalEditCompanies(props: Props) {
  const { notifySuccess, notifyError } = useToastContext();
  const [companyId, setCompanyId] = useState<string | null>(null);
  const companyData = props.data || emptyCompany;
  const handleCloseModal = () => { props.onClose() }


  useEffect(() => {
    if (companyId !== props.companyId) {
      setCompanyId(props.companyId);
    }
  }, [props.companyId, companyId]);


  // Função para lidar com o envio do formulário
  async function handleSubmit(values: ICompany) {
    try {

      const response = companyId
        ? await updateCompany(values)
        : await createCompany(values);

      const { ok, data, errors } = response;

      if (ok && data) {
        notifySuccess(`Empresa "${data.socialname}" ${companyId ? 'atualizada' : 'criada'}!`);
        props.onSave(data as ICompany);
        props.onClose();
        return { ok, data: data as ICompany, errors: (errors as unknown[]) };
      }

      notifyError(response.message || "Erro ao salvar empresa");
      return { ok: false, data: companyData, errors: response.errors as unknown[] || [] };
    } catch (err) {
      console.error(err);
      notifyError((err as Error).message || "Erro ao salvar empresa");
      return {
        ok: false,
        data: companyData, errors: [(err as Error).message || "Erro ao salvar empresa"]
      };
    }
  }

  return (
    <>
      <Modal
        size={'5xl'}
        className='relative'
        show={true}
        onClose={() => handleCloseModal()}
      >
        <Modal.Header className='text-black'>
          <div className="flex items-center justify-start gap-3 text-black">
            <span>
              {`${companyData._id ? 'Editando:' : 'Criando'} ${companyData.socialname || 'Empresa'}`}
            </span>
          </div>
        </Modal.Header>
        <Modal.Body className='w-full relative border-gray flex flex-col text-black' style={{ minHeight: 'calc(50vh - 300px)', height: 'calc(100vh - 300px)' }}>
          {companyData ? (
            <FormEditCompany
              onSubmit={handleSubmit}
              data={companyData}
              formRequestErrors={[]}
            />
          ) : <Loading />}
        </Modal.Body>
      </Modal>
    </>
  );
}